import {
	Card,
	makeStyles, Table,
	TableBody,
	TableCell,
	TableHead,
	TablePagination,
	TableRow,
	Typography
} from '@material-ui/core';
import TableContainer from "@material-ui/core/TableContainer";
import clsx from 'clsx';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';
import React from 'react';
import ActionButton from './ActionButtons';




const useStyles = makeStyles({
	root: {
		width: "100%"
	},
	container: {
		maxHeight: '440'
	}
});

const Results = ({ className, rows, columns, ...rest }) => {
	const classes = useStyles();
	const [page, setPage] = React.useState(0);
	const [rowsPerPage, setRowsPerPage] = React.useState(10);
	// const [data, setData] = React.useState(rows);

	const handleChangePage = (even, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (
		event
	) => {
		setRowsPerPage(+event.target.value);
		setPage(0);
	};

	return (
		<Card
			className={clsx(classes.root, className)}
			{...rest}
		>
			<div style={{ height: '100%', width: '100%', background: 'white' }}>
				<TableContainer className={classes.container}>
					<Table stickyHeader aria-label="sticky table" size={'small'}>
						<TableHead>
							<TableRow>
								{columns.map((column) => (
									<TableCell
										key={column.field}
										// align={column.align}
										style={{
											minWidth: column.width
										}}
									>
										{column.headerName}
									</TableCell>
								))}
							</TableRow>
						</TableHead>
						<TableBody>
							{
								rows && rows !== undefined && rows !== [] && rows !== null ?
									rows
										.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
										.map((row) => {
											if (row.removed) return null;
											return (
												<TableRow hover key={row._id}>
													{columns.map((column) => {
														if (column.field === 'reginfo') {
															return (
																<>
																	<TableCell key={column.field} align={column.align}>
																		{`${row.type} - ${row.registration_number} - ${row.registration_state}`}
																	</TableCell>
																</>
															)
														}
														if (column.field === 'actions') {
															return (
																<>
																	<TableCell key={column.field} align={column.align}>
																		<ActionButton row={row} />
																	</TableCell>
																</>
															)
														}
														const value = row[column.field];
														// console.log(column.field);
														return (
															<TableCell align={column.align} width={column.width}>
																{value}
																<Typography variant="caption" display="block" style={{ color: 'grey' }}>
																	Last seen: {row?.tracker?.status[0]?.position_timestamp ? dayjs(row?.tracker?.status[0]?.position_timestamp).fromNow() : "Never"}
																</Typography>
															</TableCell>
														);
													})}
												</TableRow>
											);
										})
									: <Typography>No Vehicles Found</Typography>
							}
						</TableBody>
					</Table>
				</TableContainer>
				<TablePagination
					rowsPerPageOptions={[10, 25, 100]}
					component="div"
					count={rows ? rows.length : 0}
					rowsPerPage={rowsPerPage}
					page={page}
					onChangePage={handleChangePage}
					onChangeRowsPerPage={handleChangeRowsPerPage}
				/>
			</div>
		</Card>
	);
};

Results.propTypes = {
	className: PropTypes.string,
	rows: PropTypes.array.isRequired,
	columns: PropTypes.array.isRequired,
};

export default Results;
